<template>
  <section class="px-16 mt-8">
    <loading-flux :value="loadingActions"></loading-flux>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <section class="d-flex flex-column flex-sm-row justify-content-between">
          <h2 class="my-3">Áreas Responsables</h2>
        </section>
      </v-col>
      <v-col cols="12" lg="12" md="12" sm="12" class="pt-0 pb-3">
        <v-btn
          @click="openModalUpdateOrCreateAssignedArea(null)"
          :disabled="loading"
          color="primary"
          :dark="false"
          class="text-white float-right mt-4 mx-3"
        >
          <i class="mdi mdi-plus me-1"></i>
          Crear Área Responsable
        </v-btn>
        <v-btn
          @click="openModalFilterAssignedAreas()"
          :disabled="loading"
          color="primary"
          :dark="false"
          class="text-white float-right mt-4"
        >
          <i class="mdi mdi-filter me-1"></i>
          Filtros
        </v-btn>
      </v-col>

      <v-col cols="12" md="12" sm="12" class="mb-2">
        <v-data-table
          :key="keyTableAssignedAreas"
          :page.sync="filters.page"
          :headers="tableHeaders"
          :items="
            assignedAreasMaintainers.items ? assignedAreasMaintainers.items : []
          "
          item-key="code"
          :items-per-page="filters.items"
          class="elevation-1"
          mobile-breakpoint="993"
          hide-default-footer
          :loading="loading"
          @update:sort-by="updateSortBy"
          @update:sort-desc="updateSortDesc"
          :custom-sort="customSort"
          no-data-text="No hay Datos para Mostrar"
          loading-text="Cargando Áreas Responsables... Espere Por favor"
        >
          <template v-slot:item.name="{ item }">
            <div class="link-text text-left">
              {{ item.name }}
            </div>
          </template>
          <template v-slot:item.business_unit="{ item }">
            <div class="link-text text-left">
              {{ item.business_unit.name }}
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="d-flex align-items-center justify-content-center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="openModalUpdateOrCreateAssignedArea(item)"
                    icon
                    color="warning"
                    v-bind="attrs"
                    v-on="on"
                    x-small
                    class="mx-2"
                  >
                    <v-icon> mdi-pencil </v-icon>
                  </v-btn>
                </template>
                <span>Editar Área Responsable</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="deleteAssignedArea(item)"
                    icon
                    color="red darken-2"
                    v-bind="attrs"
                    v-on="on"
                    x-small
                    class="mx-2"
                  >
                    <v-icon> mdi-delete </v-icon>
                  </v-btn>
                </template>
                <span>Eliminar Área Responsable</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
        <div class="text-center pt-2">
          <v-pagination
            v-model="filters.page"
            :length="
              assignedAreasMaintainers
                ? assignedAreasMaintainers.total_pages
                : 1
            "
            :total-visible="8"
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
    <modal-update-or-create-assigned-area
      ref="modalUpdateOrCreateAssignedArea"
      :modalAction="dialogUpdateOrCreateAssignedArea"
      :closeModalCreateOrUpdateAssignedArea="
        closeModalCreateOrUpdateAssignedArea
      "
      :currentAssignedArea="currentAssignedArea"
      @assignedAreaUpdatedOrCreated="
        getAssignedAreasData(filters.page);
        $emit('assignedAreaUpdatedOrCreated');
      "
    >
    </modal-update-or-create-assigned-area>
    <filters
      :modalAction="dialogFilterAssignedAreas"
      :closeModalFilterAssignedAreas="closeModalFilterAssignedAreas"
      @clearAllFilters="clearAllFilters"
      @searchFilters="searchFilters"
    >
    </filters>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ModalUpdateOrCreateAssignedArea from "./ModalUpdateOrCreateAssignedArea.vue";
import { authUsuarioComputed } from "@/state/helpers";
import Filters from "./Filters.vue";

export default {
  components: { ModalUpdateOrCreateAssignedArea, Filters },
  data() {
    return {
      keyTableAssignedAreas: 1000,
      dialogUpdateOrCreateAssignedArea: false,
      dialogFilterAssignedAreas: false,
      currentAssignedArea: null,
      loading: false,
      loadingActions: false,
      debounce: null,
      debounceFolders: null,
      debounceTime: 500,
      filters: {
        page: 1,
        items: 10,
        filter: "",
        business_unit: null,
        sort_by: "created_at",
        sort_order: "desc",
      },
      tableHeaders: [
        {
          value: "name",
          text: "Nombre",
          sortable: true,
          width: "20%",
        },
        {
          value: "business_unit",
          text: "Unidad de Negocio",
          sortable: true,
          align: "left",
          width: "15%",
        },
        {
          value: "actions",
          sortable: false,
          align: "center",
          text: "Acciones",
          width: "10%",
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      getAssignedAreas: "document/getAssignedAreas",
      deleteAssignedAreaService: "document/deleteAssignedArea",
    }),
    searchFilters(filters) {
      this.filters.filter = filters.filter;
      if (this.businessUnits.length > 1) {
        this.filters.business_unit = filters.business_unit;
      }
      this.filters.items = filters.items;
      this.getAssignedAreasData();
    },
    clearAllFilters() {
      this.filters.filter = null;
      if (this.businessUnits.length > 1) {
        this.filters.business_unit = null;
      }
      this.filters.items = 10;
      this.getAssignedAreasData();
    },
    async getAssignedAreasData(page = 1) {
      clearTimeout(this.debounce);
      let self = this;
      this.debounce = await setTimeout(async function() {
        self.loading = true;
        self.filters.page = page;
        await self.getAssignedAreas({
          page: self.filters.page,
          items: self.filters.items,
          filter: self.filters.filter,
          business_unit_filter: self.filters.business_unit
            ? self.filters.business_unit.toUpperCase()
            : null,
          show_all: false,
          sort_by: self.filters.sort_by,
          sort_order: self.filters.sort_order,
        });
        // self.keyTableAssignedAreas = self.keyTableAssignedAreas + 1;
        self.loading = false;
      }, self.debounceTime);
    },
    async updateSortBy(sortBy) {
      if (sortBy) {
        this.filters.sort_by = sortBy;
        this.filters.sort_order = "asc";
        await this.getAssignedAreasData();
      } else {
        this.filters.sort_by = "created_at";
        this.filters.sort_order = "desc";
        await this.getAssignedAreasData();
      }
    },
    async updateSortDesc(sortDesc) {
      if (sortDesc) {
        this.filters.sort_order = "desc";
        await this.getAssignedAreasData();
      }
    },
    customSort(items, index, isDesc, column) {
      return items;
    },
    openModalUpdateOrCreateAssignedArea(assignedArea) {
      this.currentAssignedArea = assignedArea;
      this.$refs.modalUpdateOrCreateAssignedArea.setBusinessUnitUser();
      this.dialogUpdateOrCreateAssignedArea = true;
    },
    closeModalCreateOrUpdateAssignedArea() {
      this.currentAssignedArea = null;
      this.dialogUpdateOrCreateAssignedArea = false;
    },
    openModalFilterAssignedAreas() {
      this.dialogFilterAssignedAreas = true;
    },
    closeModalFilterAssignedAreas() {
      this.dialogFilterAssignedAreas = false;
    },
    async deleteAssignedArea(assignedArea) {
      let self = this;
      this.$swal
        .fire({
          icon: "warning",
          title:
            "¿Estás seguro de eliminar el área responsable: " +
            assignedArea.name +
            "?",
          text: "Esta acción no se puede deshacer",
          showCancelButton: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "red",
          reverseButtons: true,
        })
        .then(async (result) => {
          if (result.value) {
            this.loadingActions = true;
            const resp = await this.deleteAssignedAreaService({
              area_id: assignedArea.id,
            });
            if (resp.status == 200) {
              this.$swal.fire({
                icon: "success",
                title: "Excelente",
                text:
                  "El área responsable: " +
                  assignedArea.name +
                  " ha sido eliminada correctamente",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 5000,
                timerProgressBar: true,
              });
              this.getAssignedAreasData();
            }
            this.loadingActions = false;
          }
        });
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      assignedAreasMaintainers: "document/assignedAreasMaintainers",
      businessUnits: "document/businessUnits",
    }),
  },
  watch: {
    "filters.page": function(page) {
      this.getAssignedAreasData(page);
    },
    businessUnits: function(bussinesUnits) {
      if (bussinesUnits.length > 1) {
        this.getAssignedAreasData();
      } else {
        this.filters.business_unit = this.businessUnits.length
          ? this.businessUnits[0].code
          : null;
        if (this.filters.business_unit) {
          this.getAssignedAreasData();
        }
      }
    },
  },
};
</script>

<style></style>
